import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, catchError, of, tap } from 'rxjs';
import { TokenService } from './token.service';

interface DeclarationRequest {
  subsidy: boolean;
  sector: boolean;
  energy: boolean;
  company: boolean;
  confirm: boolean;
  pair?: {
    vat_number: string;
    company: string;
  }[];
}

interface DeclarationResponse {
  success: boolean;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})


export class ValidationService {
  private readonly baseUrl = 'https://power4business.deddie.gr/api';

  constructor(
    private http: HttpClient,
    private tokenService: TokenService
  ) {}

  

  /**
   * Validate the subsidy endpoint
   * 
   * @returns Observable with subsidy data or null if validation fails
   */
  getAllUserMeters(): Observable<any> {
    console.log('Validating subsidy endpoint...');
    
    // This will automatically use the auth interceptor to add the token
    return this.http.get<any>(`${this.baseUrl}/deddie_meters`)
      .pipe(
        tap(response => {
          console.log('Subsidy validation successful:', response);
        }),
        catchError(error => {
          console.error('Subsidy validation failed:', error);
          
          // If the error is due to authentication, check token status
          if (error.status === 401) {
            console.log('Authentication failed during validation, checking token...');
            
            // Check if we have a token
            if (this.tokenService.isAuthenticated()) {
              console.log('Token exists but may be invalid, attempting refresh...');
              this.tokenService.refreshToken()
                .then(refreshed => {
                  console.log('Token refresh result:', refreshed);
                });
            } else {
              console.log('No token available, user needs to authenticate');
            }
          }
          
          // Return null or an error object instead of throwing
          return of(null);
        })
      );
  }

 submitDeclaration(declaration: DeclarationRequest): Observable<any> {
  console.log('Submitting declaration...', declaration);
  
  return this.http.post<any>(`${this.baseUrl}/declaration/`, declaration)
    .pipe(
      tap(response => {
        console.log('Declaration submission successful:', response);
      }),
      catchError(error => {
        // Check if we have a response with status 200 in the error object
        // This can happen when the request succeeds but the response format is unexpected
        if (error.status === 200) {
          return of({ success: true, data: error.error });
        }
        
        console.error('Declaration submission failed:', error);
        
        // If the error is due to authentication, check token status
        if (error.status === 401) {
          console.log('Authentication failed during declaration submission');
        }
        
        // Return a standardized error response
        return of({ 
          success: false, 
          message: error.message || 'Unknown error',
          status: error.status
        });
      })
    );
}



 // Add this method to your ValidationService

requestMeterValidation(params: HttpParams): Observable<any> {
  console.log('Validating selected meters...');
  
  // This will automatically use the auth interceptor to add the token
  return this.http.post<any>(`${this.baseUrl}/subsidy`, { params })
    .pipe(
      tap(response => {
       
      }),
      catchError(error => {

      
        console.error('Meter validation failed:', error);
        
        // If the error is due to authentication, check token status
        if (error.status === 401) {
          console.log('Authentication failed during validation');
        }
        
        // Return null or an error object instead of throwing
        return of(null);
      })
    );
}


checkPreviousInput(): Observable<any> {
  console.log('Validating selected meters...');
  
  // This will automatically use the auth interceptor to add the token
  return this.http.get<any>(`${this.baseUrl}/subsidy`, {  })
    .pipe(
      tap(response => {
        console.log('Meter validation successful:', response);
      }),
      catchError(error => {

      
        console.error('Meter validation failed:', error);
        
        // If the error is due to authentication, check token status
        if (error.status === 401) {
          console.log('Authentication failed during validation');
        }
        
        // Return null or an error object instead of throwing
        return of(null);
      })
    );
}

sendResetMessage(): Observable<any> {
  console.log('Validating selected meters...');
  
  // This will automatically use the auth interceptor to add the token
  return this.http.put<any>(`${this.baseUrl}/subsidy`, {  })
    .pipe(
      tap(response => {
        console.log('ANAKLISI SUCCESSFUL successful:', response);
      }),
      catchError(error => {

      
        console.error('Meter validation failed:', error);
        
        // If the error is due to authentication, check token status
        if (error.status === 401) {
          console.log('Authentication failed during validation');
        }
        
        // Return null or an error object instead of throwing
        return of(null);
      })
    );
}

completeResults(): Observable<any> {
  console.log('Validating selected meters...');
  
  // This will automatically use the auth interceptor to add the token
  return this.http.put<any>(
    `${this.baseUrl}/subsidy?submit=true`, 
    { submit: true }
  ).pipe(
    tap(response => {
      console.log('ANAKLISI SUCCESSFUL successful:', response);
    }),
    catchError(error => {
      console.error('Meter validation failed:', error);
      
      // If the error is due to authentication, check token status
      if (error.status === 401) {
        console.log('Authentication failed during validation');
      }
      
      // Return null or an error object instead of throwing
      return of(null);
    })
  );
}
/**
 * Submit personal information to the server
 * 
 * @param personalInfo Object containing user's personal information
 * @returns Observable with the response or error information
 */
submitPersonalInfo(personalInfo: {
  first_name: string;
  last_name: string;
  mobile_number: string;
  email: string;
}): Observable<any> {
  console.log('Submitting personal information:', personalInfo);
  
  return this.http.post<any>(`${this.baseUrl}/personal_info/`, personalInfo)
    .pipe(
      tap(response => {
        console.log('Personal info submission successful:', response);
      }),
      catchError(error => {
            if (error.status === 200) {
          return of({ success: true, data: error.error });
        }
        console.error('Personal info submission failed:', error);
        
        // If the error is due to authentication, check token status
        if (error.status === 401) {
          console.log('Authentication failed during personal info submission');
          
          // Check if we have a token
          if (this.tokenService.isAuthenticated()) {
            console.log('Token exists but may be invalid, attempting refresh...');
            this.tokenService.refreshToken()
              .then(refreshed => {
                console.log('Token refresh result:', refreshed);
              });
          } else {
            console.log('No token available, user needs to authenticate');
          }
        }
        
        // Return error info instead of throwing
        return of({
          success: false,
          error: error.error || 'Unknown error',
          status: error.status
        });
      })
    );
}

 
}